import { Component, ElementRef, inject, OnDestroy, OnInit, Signal, ViewChild } from '@angular/core';
import { LogoComponent } from '../../shared/logo/logo.component';
import { ActionButtonsComponent } from './action-buttons/action-buttons.component';
import { RelatedPreviewsComponent } from './related-previews/related-previews.component';
import { DvmService } from '@services/dvm.service';
import { Subscription } from 'rxjs';
import { Viewer3dService } from '@3ddv/ngx-dvm-internal';
import { MinimapComponent } from './minimap/minimap.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { SearchComponent } from '../topbar/navigation/search/search.component';
import { MenuButtonsComponent } from '../topbar/menu/menu-buttons/menu-buttons.component';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import anime from 'animejs';
import { BenefitsButtonComponent } from "../topbar/benefits/benefits-button/benefits-button.component";
import { LayoutService } from '@services/layout.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    SearchComponent,
    MenuButtonsComponent,
    MinimapComponent,
    RelatedPreviewsComponent,
    LogoComponent,
    ActionButtonsComponent,
    DisclaimerComponent,
    BenefitsButtonComponent
],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit, OnDestroy {

  // VIEW CHILDS
  @ViewChild('footerContainer', { static: true })
  private readonly footerContainer!:  ElementRef<HTMLElement>;

  // SERVICES
  private readonly dvmService:        DvmService            = inject(DvmService);
  private readonly layout:            LayoutService         = inject(LayoutService);

  // GLOBAL STATE
  protected readonly view:            Signal<AppViews|null> = this.dvmService.view;
  protected readonly isMobile:        Signal<boolean>       = this.layout.isMobile;
  protected readonly AppViews:        typeof AppViews       = AppViews;

  // COMPONENT STATE
  private readonly subscription:      Subscription[] = [];
  protected        hideElement:       boolean        = false;

  // LIFECYCLE HOOKS
  ngOnInit(): void {
    this.initComponent();
  }

  ngOnDestroy(): void {
    this.destroyComponent();
  }

  // METHODS

  /**
   * Iniciamos el footer esperando a que cargue el viewer 3d para suscribirnos a sus triggers.
   */
  private initComponent(): void {

    const viewer3d: Viewer3dService = this.dvmService.viewer3d;

    viewer3d.waitInitialize().subscribe((): void => this.initSuscriptions());

  }

  /**
   * Escuchamos los triggers de full screen para mostrar u ocultar el footer.
   */
  private initSuscriptions(): void {

    const viewer3d: Viewer3dService = this.dvmService.viewer3d;

    this.subscription.push(
      viewer3d.getObservable('fullscreen_enabled').subscribe((): void => this.toggleVisibility(false)),
      viewer3d.getObservable('fullscreen_disabled').subscribe(():void => this.toggleVisibility(true)),
    )

  }

  /**
   * Destruimos el componente y nos desuscribimos de los triggers del viewer 3d.
   */
  private destroyComponent(): void {

    this.subscription.forEach((subscription: Subscription): void => subscription.unsubscribe());

  }

  /**
   * Muestra u oculta el footer dependiendo del estado de la variable show.
   * Si hideElement es true, significa que el footer está oculto y no se puede mostrar, por ello si show es true, revertimos este estado
   * antes de la animación. 
   * @param {boolean} show 
   */
  private toggleVisibility(show: boolean): void {

    if(show && this.hideElement) this.hideElement = false;

    anime({
      targets:  this.footerContainer.nativeElement,
      opacity:  show ? 1 : 0,
      easing:   'easeInOutQuad',
      duration: 300,
      complete: (): void => { if(!show && !this.hideElement) this.hideElement = true },
    })

  }


}
